
    const data = {"name":"src/core/icons/format-italic","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            